module.exports = __webpack_public_path__ + "static/media/reactnative.f81115b5.png";